// Get Billing Invoices
export const GET_BILLING_INVOICES_REQUEST = 'GET_BILLING_INVOICES_REQUEST';
export const GET_BILLING_INVOICES_DONE = 'GET_BILLING_INVOICES_DONE';
export const GET_BILLING_INVOICES_FAILED = 'GET_BILLING_INVOICES_FAILED';
export const GET_BILLING_INVOICES_RESET = 'GET_BILLING_INVOICES_RESET';

//Operations
export const BILLING_INVOICES_SET_PAGE = 'BILLING_INVOICES_SET_PAGE';
